import * as types from '../mutation-types'
import couponService from '../services/coupon'

// state
export const state = {
    coupons: {},
    currentCoupon: null,
    loading: false,
    error: false,
    errors: [],
    responseMessage: ''
}

// getters
export const getters = {
    isLoading: state => state.loading,
    getErrors: state => state.errors,
    responseMessage: state => state.responseMessage
}

// mutations
export const mutations = {
    [types.SET_COUPONS](state, coupons) {
        state.coupons = coupons
    },
    [types.SET_CURRENT_COUPON](state, coupon) {
        state.currentCoupon = coupon
    },
    [types.SET_LOADING](state, loading) {
        state.loading = loading
    },
    [types.SET_ERROR](state, error) {
        state.error = error
    },
    [types.SET_ERROR_STATE](state, payload) {
        state.errors = []
        const errors = []
        if (payload.response?.status === 422) {
            for (const key in payload.response?.data?.errors) {
                errors.push(payload.response?.data?.errors[key][0])
            }
        } else if (payload.response?.status === 400 || payload.response?.status === 401) {
            errors.push(payload.response?.data?.message)
        }
        state.errors = [...errors]
    },
    [types.SET_RESPONSE_MSG](state, message) {
        state.responseMessage = message
    },
    [types.REMOVE_COUPON](state, id) {
        if (state.coupons && Array.isArray(state.coupons.data)) {
            state.coupons.data = state.coupons.data.filter(coupon => coupon.id !== id)
        }
    }
}

// actions
export const actions = {
    async getAllCoupons({ commit }, payload) {
        commit(types.SET_LOADING, true)

        let searchText = ''
        let page = 1
        let perPage = 10
        let sortColumn = ''
        let order = ''

        if (payload && payload.data) {
            searchText = payload.data.search || ''
            page = payload.data.page || 1
            perPage = payload.data.rows || 10
            sortColumn = payload.data.sortColumn || ''
            order = payload.data.order === 'asc' ? 'ASC' : 'DESC'
        }

        try {
            const response = await couponService.getAllCoupons(searchText, page, perPage, sortColumn, order)
            commit(types.SET_COUPONS, response.data)
            return response.data
        } catch (error) {
            commit(types.SET_ERROR, true)
            commit(types.SET_ERROR_STATE, error)
            throw error
        } finally {
            commit(types.SET_LOADING, false)
        }
    },

    async getCoupon({ commit }, id) {
        commit(types.SET_LOADING, true)

        try {
            const response = await couponService.getCoupon(id)
            commit(types.SET_CURRENT_COUPON, response.data)
            return response.data
        } catch (error) {
            commit(types.SET_ERROR, true)
            commit(types.SET_ERROR_STATE, error)
            throw error
        } finally {
            commit(types.SET_LOADING, false)
        }
    },

    async createCoupon({ commit }, data) {
        commit(types.SET_LOADING, true)

        try {
            const response = await couponService.createCoupon(data)
            commit(types.SET_RESPONSE_MSG, 'Coupon created successfully')
            return response.data
        } catch (error) {
            commit(types.SET_ERROR, true)
            commit(types.SET_ERROR_STATE, error)
            throw error
        } finally {
            commit(types.SET_LOADING, false)
        }
    },

    async updateCoupon({ commit }, { id, data }) {
        commit(types.SET_LOADING, true)

        try {
            const response = await couponService.updateCoupon(id, data)
            commit(types.SET_RESPONSE_MSG, 'Coupon updated successfully')
            return response.data
        } catch (error) {
            commit(types.SET_ERROR, true)
            commit(types.SET_ERROR_STATE, error)
            throw error
        } finally {
            commit(types.SET_LOADING, false)
        }
    },

    async deleteCoupon({ commit }, id) {
        commit(types.SET_LOADING, true)

        try {
            await couponService.deleteCoupon(id)
            commit(types.REMOVE_COUPON, id)
            commit(types.SET_RESPONSE_MSG, 'Coupon deleted successfully')
        } catch (error) {
            commit(types.SET_ERROR, true)
            commit(types.SET_ERROR_STATE, error)
            throw error
        } finally {
            commit(types.SET_LOADING, false)
        }
    },
}
